import { buildProperty, type EntityStatus } from "@firecms/core";

export type ContentTimestamps = {
  createdAt: Date;
  updatedAt: Date;
};

export const contentTimestampsProperties = {
  createdAt: buildProperty({
    name: "Created",
    dataType: "date",
    readOnly: true,
    autoValue: "on_create",
    hideFromCollection: true,
  }),
  updatedAt: buildProperty({
    name: "Updated",
    dataType: "date",
    readOnly: true,
    autoValue: "on_update",
    hideFromCollection: true,
  }),
};

export const onPreSaveContentTimestamps = <T extends ContentTimestamps = ContentTimestamps>({
  values,
  status,
}: {
  values: Partial<T>;
  status: EntityStatus;
}): Partial<T> => {
  const now = new Date();
  if (status === "new" || !values.createdAt) {
    values.createdAt = now as T["createdAt"];
  }
  values.updatedAt = now as T["updatedAt"];
  return values;
};

export const onPreSaveContentEntity = <T extends ContentTimestamps = ContentTimestamps>(params: {
  values: Partial<T>;
  status: EntityStatus;
}) => onPreSaveContentTimestamps(params);
